<template>
  <div>
    <empty-state
      v-if="loading || !data || data.length === 0"
      :loading="loading"
      :title="loading ? $t('loading') : $t('no_taken_meals_data')"
      :subtitle="!loading ? $t('no_taken_found') : ''"
      icon="mdi-cart-check"
    />
    <div v-else class="pa-1">
      <!-- Mobile View -->
      <mobile-data-cards
        v-if="device.isMobile"
        :headers="mobileHeaders"
        :items="customSearch(data, mobileHeaders, searchQuery)"
        :loading="loading"
        item-key="menu"
        :fields-per-row="5"
        :show-row-number="false"
        :bold-fields="['total']"
      />

      <!-- Desktop View -->
      <v-data-table
        v-else
        :headers="headers"
        :items="customSearch(data, headers, searchQuery)"
        class="striped-table ordera-box-shadow"
        :loading="loading"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:item.num="{ index }">
          {{ index + 1 }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import EmptyState from "@/components/global/EmptyState.vue";
import MobileDataCards from "@/components/global/MobileDataCards.vue";

export default {
  name: "TakenTable",
  components: {
    EmptyState,
    MobileDataCards,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: "",
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("r_b"), value: "num", sortable: false },
        { text: this.$t("company"), value: "menu", sortable: false },
        {
          text: this.$t("shift_one"),
          value: "shift_one",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("shift_two"),
          value: "shift_two",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("shift_three"),
          value: "shift_three",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("quantity"),
          value: "total",
          sortable: false,
          align: "center",
        },
      ];
    },
    mobileHeaders() {
      return [
        { text: this.$t("company"), value: "menu", sortable: false, cols: 6 },
        {
          text: this.$t("shift_one"),
          value: "shift_one",
          sortable: false,
          align: "center",
          cols: 2,
        },
        {
          text: this.$t("shift_two"),
          value: "shift_two",
          sortable: false,
          align: "center",
          cols: 2,
        },
        {
          text: this.$t("shift_three"),
          value: "shift_three",
          sortable: false,
          align: "center",
          cols: 2,
        },
      ];
    },
  },
};
</script>
